export const SET_TOURNAMENT_FOR_SETUP = 'SET_TOURNAMENT_FOR_SETUP';



// WEBPACK FOOTER //
// ./src/features/tournament/constants.js